<div class="heatmap-wrapper">

    <ng-container *ngIf="mappedChartData">

        <app-heatmap-chart-with-table
                [chartData]="mappedChartData"
                [chartContainer]="chartContainer"
                [baseColor]="baseColor"
                [maxValue]="extractedMaxValue"
                [tableTitle]="tableTitle"
                [tooltipFormatter]="tooltipFormatter"
                [valueFormat]="valueFormat"
                [valueFormatter]="valueFormatter">
        </app-heatmap-chart-with-table>
    </ng-container>
</div>
